import { AmbientGlow, TapeLabel } from "./_shared";

// Ported from Claude Design handoff (sections-rest: HowItWorks).
// 3 numbered circles + horizontal timeline rail below. No blue box.

const STEPS = [
  {
    n: "01",
    title: "Fale Conosco",
    body:
      "Converse com nosso consultor, entenda o plano ideal e deixe a configuração por nossa conta.",
  },
  {
    n: "02",
    title: "Configuramos Tudo",
    body:
      "Em 24-48h, seus domínios e endpoints já estão sendo monitorados. Sem instalação, sem complicação.",
  },
  {
    n: "03",
    title: "Você Acompanha",
    body:
      "Receba alertas inteligentes e relatórios mensais em PDF que qualquer pessoa da sua equipe entende.",
  },
];

const TIMELINE = [
  { time: "24 horas", event: "Monitoramento ativo, primeiros alertas chegando" },
  { time: "48 horas", event: "Primeiro relatório com IA em português" },
  { time: "1 semana", event: "Check-in com especialista Cyphron" },
  {
    time: "1 mês",
    event: "Análise de tendências e score de segurança consolidado",
  },
];

export function HowItWorksSteps() {
  return (
    <section
      id="como-funciona"
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tr-bl" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: 720,
            marginInline: "auto",
            marginBottom: 72,
          }}
        >
          <TapeLabel>COMO FUNCIONA</TapeLabel>
          <h2
            style={{
              fontFamily: "var(--cy-fs-sans)",
              fontSize: "clamp(36px, 4.5vw, 52px)",
              lineHeight: 1.05,
              letterSpacing: "-0.03em",
              fontWeight: 500,
              margin: "20px 0 0",
              color: "var(--cy-ink-100)",
              textWrap: "balance",
            }}
          >
            Comece a proteger sua empresa em 3 passos
          </h2>
        </div>

        <div
          className="cy-grid-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 20,
          }}
        >
          {STEPS.map((s) => (
            <div
              key={s.n}
              style={{
                padding: "32px 28px 30px",
                border: "1px solid var(--cy-ink-10)",
                background: "rgba(132,255,0,0.02)",
                transition: "border-color .2s ease, background .2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(132,255,0,0.18)";
                e.currentTarget.style.background = "rgba(132,255,0,0.035)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--cy-ink-10)";
                e.currentTarget.style.background = "rgba(132,255,0,0.02)";
              }}
            >
              <div
                className="cy-mono"
                style={{
                  fontSize: 32,
                  fontWeight: 500,
                  letterSpacing: "-0.01em",
                  color: "var(--cy-accent)",
                  marginBottom: 24,
                  lineHeight: 1,
                }}
              >
                {s.n}
              </div>
              <div
                style={{
                  fontFamily: "var(--cy-fs-sans)",
                  fontSize: 20,
                  fontWeight: 500,
                  letterSpacing: "-0.015em",
                  color: "var(--cy-ink-100)",
                  marginBottom: 12,
                }}
              >
                {s.title}
              </div>
              <div
                style={{
                  fontSize: 14.5,
                  lineHeight: 1.55,
                  color: "var(--cy-ink-60)",
                }}
              >
                {s.body}
              </div>
            </div>
          ))}
        </div>

        {/* Timeline — dark panel matching section darkness */}
        <div
          style={{
            marginTop: 80,
            padding: "32px 40px",
            border: "1px solid var(--cy-ink-10)",
            background: "rgba(132,255,0,0.02)",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <span className="cy-tape">Tempo para valor</span>
          </div>
          <div
            className="cy-grid-4"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 0,
              position: "relative",
            }}
          >
            <div
              aria-hidden
              className="cy-timeline-rail"
              style={{
                position: "absolute",
                top: 16,
                left: "12%",
                right: "12%",
                height: 2,
                background: "var(--cy-ink-10)",
              }}
            />
            {TIMELINE.map((t, i) => (
              <div
                key={i}
                style={{ textAlign: "center", position: "relative" }}
              >
                <div
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: "var(--cy-accent)",
                    margin: "10px auto 16px",
                    boxShadow:
                      "0 0 0 4px var(--cy-bg), 0 0 12px var(--cy-accent-glow)",
                    position: "relative",
                    zIndex: 1,
                  }}
                />
                <div
                  className="cy-mono"
                  style={{
                    fontSize: 13,
                    color: "var(--cy-accent)",
                    marginBottom: 6,
                  }}
                >
                  {t.time}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: "var(--cy-ink-80)",
                    lineHeight: 1.45,
                    maxWidth: 200,
                    marginInline: "auto",
                  }}
                >
                  {t.event}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
